import { ChartWidgetMetadata } from '@/modules/ta/widget/models/metadata/ChartWidgetMetadata';
import { PivotTableChartDrawOption } from '@/modules/ta/widget/models/drawoptions/PivotTableChartDrawOption';

export class PivotTableChartWidgetMetadata extends ChartWidgetMetadata {
  constructor(model = {}) {
    super(model);

    this.draw_options = new PivotTableChartDrawOption(model.draw_options);
  }
}
